import type { RootState } from 'app'
import { createSelector } from '@reduxjs/toolkit'
import { LoadingStatus } from 'shared/types'

const getInvoicesState = (state: RootState) => state.Invoices

export const getFilters = createSelector(
  getInvoicesState,
  state => state.filters
)

export const getSearch = createSelector(getFilters, filters => filters.search)

export const getInvoiceState = createSelector(
  getInvoicesState,
  state => state.getInvoice
)

export const getInvoiceDeleteState = createSelector(
  getInvoicesState,
  state => state.deleteInvoice
)

export const getSetInvoiceAsPaidState = createSelector(
  getInvoicesState,
  state => state.setInvoiceAsPaid
)

export const getCollapsedInvoiceId = createSelector(
  getInvoicesState,
  state => state.collapsedInvoiceId
)

export const getSuccessDialogState = createSelector(
  getInvoicesState,
  state => state.addDueSuccessDialog
)

export const getFilePreviewState = createSelector(
  getInvoicesState,
  state => state.filePreview
)

export const getFilePreviewDialogState = createSelector(
  getInvoicesState,
  state => state.filePreview.data.isDialogOpen
)

export const getImportDialogState = createSelector(
  getInvoicesState,
  state => state.importFile.isDialogOpen
)
export const getRequiredColumns = createSelector(
  getInvoicesState,
  state => state.requiredColumns.data
)

export const getFileImportSummaryState = createSelector(
  getInvoicesState,
  state => state.fileImportSummary
)

export const getAddInvoiceDialogState = createSelector(
  getInvoicesState,
  state => state.addInvoiceDialog
)

export const getFileImportSummaryReportState = createSelector(
  getInvoicesState,
  state => state.fileImportSummaryReport
)

export const getFileImportExistingInvoicesState = createSelector(
  getInvoicesState,
  state => state.fileImportExistingInvoices
)

export const getFileImportLawsuitAlreadyFiledState = createSelector(
  getInvoicesState,
  state => state.fileImportLawsuitAlreadyFiled
)

export const getRefetchInvoices = createSelector(
  getInvoicesState,
  state => state.refetchInvoices
)

export const getAcceptImportState = createSelector(
  getInvoicesState,
  state => state.acceptImport
)

export const getSavedMappingState = createSelector(
  getInvoicesState,
  state => state.savedMapping
)

export const getValidateInvoiceState = createSelector(
  getInvoicesState,
  state => state.validateInvoice
)

export const getImportTemplateState = createSelector(
  getInvoicesState,
  state => state.importTemplate
)

export const getLastInvoiceImportsState = createSelector(
  getInvoicesState,
  state => state.lastInvoiceImports
)

export const getPreTrialRequestForPaymentDialogsState = createSelector(
  getInvoicesState,
  state => state.preTrialRequestForPaymentDialogs
)

export const getPreTrialPaymentRequestPreviewState = createSelector(
  getInvoicesState,
  state => state.preTrialPaymentRequestPreview
)

export const getBatchActionsState = createSelector(
  getInvoicesState,
  state => state.batchActions
)

export const getDeleteMultipleInvoicesState = createSelector(
  getBatchActionsState,
  state => state.delete
)

export const getSetMultipleInvoicesAsPaidState = createSelector(
  getBatchActionsState,
  state => state.setAsPaid
)

export const getSendMultipleNotificationsState = createSelector(
  getBatchActionsState,
  state => state.sendNotifications
)

export const getIsBatchActionLoading = createSelector(
  getBatchActionsState,
  ({
    delete: { loading: deletingStatus },
    sendNotifications: { loading: sendNotificationStatus },
    setAsPaid: { loading: setAsPaidStatus },
  }) =>
    [deletingStatus, setAsPaidStatus, sendNotificationStatus].includes(
      LoadingStatus.Pending
    )
)

export const getInvoiceHistoryState = createSelector(
  getInvoicesState,
  state => state.invoiceHistory
)
